export default "__VITE_ASSET__BMewwuYs__"